import { useActivePurchases } from 'my-purchases/hooks/useActivePurchases/useActivePurchases'
import { useInactivePurchases } from 'my-purchases/hooks/useInactivePurchases/useInactivePurchases'
import { getPurchasesErrors } from 'my-purchases/utils/getPurchasesError'

export const usePurchases = (forceLoadInactivePurchases = false) => {
	const {
		purchases: activePurchases,
		error: activePurchasesErrorCode,
		reload: reloadActivePurchases,
		isLoading: isActivePurchasesLoading,
	} = useActivePurchases()

	// This indicates if inactive purchases needs to be loaded automatically
	const loadInactivePurchases =
		!activePurchasesErrorCode && activePurchases && activePurchases.length === 0

	const disableInactivePurchases =
		!forceLoadInactivePurchases && !loadInactivePurchases

	const {
		purchases: inactivePurchases,
		error: inactivePurchasesErrorCode,
		reload: reloadInactivePurchases,
		isLoading: isInActivePurchasesLoading,
	} = useInactivePurchases(disableInactivePurchases)

	const isLoading = isActivePurchasesLoading || isInActivePurchasesLoading

	const errors = !isLoading
		? getPurchasesErrors({
				activePurchases,
				inactivePurchases,
				activePurchasesError: activePurchasesErrorCode,
				inactivePurchasesError: inactivePurchasesErrorCode,
			})
		: null

	return {
		activePurchases,
		inactivePurchases,
		isActivePurchasesLoading,
		isInActivePurchasesLoading,
		reloadActivePurchases,
		reloadInactivePurchases,
		isLoading,
		errors,
	}
}
